import { render, staticRenderFns } from "./ModifyProfileInBox.vue?vue&type=template&id=7a92bce5&"
import script from "./ModifyProfileInBox.vue?vue&type=script&lang=js&"
export * from "./ModifyProfileInBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports